import { CheckIcon } from "@heroicons/react/24/solid";
import { tinaField } from "tinacms/dist/react";
import ButtonPrimary from "./ButtonPrimary";
import type { PageHomePricing } from "../../../tina/__generated__/types";
import "./FeatureComparisonPriceTable.css";

interface FeatureCompearisonPriceTableProps {
  pricing: PageHomePricing | null;
}

export const FeatureCompearisonPriceTable = ({ pricing }: FeatureCompearisonPriceTableProps) => {
  if (!pricing) return null;

  const plans = pricing.plans?.filter((plan) => plan !== null) ?? [];

  return (
    <section className="pricing-section" aria-labelledby="pricing-title">
      <div className="pricing-heading">
        <p className="eyebrow" data-tina-field={tinaField(pricing, "eyebrow")}>
          {pricing.eyebrow}
        </p>
        <h2 id="pricing-title" className="section-title" data-tina-field={tinaField(pricing, "title")}>
          {pricing.title}
        </h2>
        <p data-tina-field={tinaField(pricing, "description")}>{pricing.description}</p>
      </div>

      <div className="pricing-grid">
        {plans.map((plan) => {
          const features = plan.features?.filter((feature): feature is string => feature !== null) ?? [];

          return (
            <article
              className={`pricing-card${plan.featured ? " pricing-card-featured" : ""}`}
              key={plan.name}
              data-tina-field={tinaField(plan)}
            >
              {plan.badge && (
                <span className="pricing-badge" data-tina-field={tinaField(plan, "badge")}>
                  {plan.badge}
                </span>
              )}
              <div className="pricing-card-content">
                <p className="pricing-plan-label" data-tina-field={tinaField(plan, "label")}>
                  {plan.label}
                </p>
                <h3 data-tina-field={tinaField(plan, "name")}>{plan.name}</h3>
                <p className="pricing-description" data-tina-field={tinaField(plan, "description")}>
                  {plan.description}
                </p>
                <div className="pricing-price" data-tina-field={tinaField(plan, "price")}>
                  <span data-tina-field={tinaField(pricing, "currencySymbol")}>{pricing.currencySymbol ?? "£"}</span>
                  {plan.price}
                  <small data-tina-field={tinaField(plan, "duration")}>{plan.duration}</small>
                </div>
                <ButtonPrimary
                  url={plan.ctaHref ?? "/booking"}
                  label={plan.ctaLabel ?? ""}
                  dataTinaField={tinaField(plan, "ctaHref")}
                  labelDataTinaField={tinaField(plan, "ctaLabel")}
                />
                <ul className="pricing-features">
                  {features.map((feature, index) => (
                    <li key={`${feature}-${index}`} data-tina-field={tinaField(plan, "features", index)}>
                      <CheckIcon aria-hidden="true" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default FeatureCompearisonPriceTable;
